import React, { useEffect, useState } from "react";
import { Box, Grid2, Typography } from "@mui/material";
import SubTabs from "components/SubTabs";
import subTabsItems from "components/subTabs-items";
import TopPerformingVendors from "./VendorPerformanceTracker/TopPerformingVendors";
import NonPerformingVendors from "./VendorPerformanceTracker/NonPerformingVendors";
import SCurveProcurement from "./Procurement/SCurveProcurement";
import LongLeadItems from "./Procurement/LongLeadItems";
import MaterialReceiptTrend from "./Procurement/MaterialReceiptTrend";
import MaterialReceiptList from "./Procurement/MaterialReceiptList";
import VendorListData from "./VendorPerformanceTracker/VendorList";
import LongLeadItemsSecond from "./Procurement/LongLeadItemSecond";
import { useCheckMenuPermission } from "hooks/useCheckMenuPermission";
import VendorHeatmap from "./VendorPerformanceTracker/VendorHeatMap";

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
        </div>
    );
}

const Procurement = () => {

    const { hasPermission } = useCheckMenuPermission();
    const [value, setValue] = useState(null);

    useEffect(() => {
        const storedIndex = localStorage.getItem("procurementTabIndex");
        if (storedIndex !== null) {
            setValue(Number(storedIndex));
        } else {
            const firstPermittedTab = subTabsItems?.procurementSubTabs?.find(item =>
                hasPermission([item?.permissionKey])
            );
            if (firstPermittedTab != undefined) {
                localStorage.setItem("procurementTabIndex", firstPermittedTab.index ?? 0);
                setValue(firstPermittedTab?.index ?? 0)
            }
        }
    }, [hasPermission, subTabsItems]);

    const handleChange = (newIndex) => {
        setValue(newIndex);
        localStorage.setItem("procurementTabIndex", newIndex);
    };

    return (
        <>
            <SubTabs subTabs={subTabsItems?.procurementSubTabs} selectedTab={handleChange} selectedIndex={value} />
            <CustomTabPanel value={value} index={0}>
                <Grid2 size={12} sx={{ mt: "20px" }}>
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems={{ xs: "flex-start", md: "center" }}
                        flexDirection={{ xs: "column", md: "row" }}
                        gap={1}
                    >
                        <Typography
                            variant="h5"
                            sx={{
                                fontSize: '20px',
                                fontWeight: '500',
                                color: "#000000",
                                mb: { xs: 0.5, md: 1 },
                                lineHeight: "100%",
                                letterSpacing: '-0.4px',
                                textAlign: { xs: "center", md: "left" },
                                width: { xs: "100%", md: "auto" },
                            }}
                        >
                            Status overview of all Projects
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                fontWeight: '400',
                                color: "#858EA0",
                                mb: { xs: 1, md: 1 },
                                lineHeight: "100%",
                                letterSpacing: '-0.4px',
                                textAlign: { xs: "center", md: "right" },
                                width: { xs: "100%", md: "auto" },
                            }}
                        >
                            Last Modified on 10th June 2025
                        </Typography>
                    </Box>
                    <Typography
                        variant="h5"
                        sx={{
                            fontSize: '18px',
                            fontWeight: '400',
                            mb: "30px",
                            color: '#182A4E80',
                            lineHeight: "100%",
                            letterSpacing: '-0.4px',
                            textAlign: { xs: "center", md: "left" },
                        }}
                    >
                        Get the snapshot of the status of all your currently running projects. You can also navigate to the individual project dashboards
                    </Typography>
                </Grid2>

                {/* <Grid2 container columnSpacing={1.25} rowSpacing={1.25}>
                    <Grid2 size={{ xs: 12, md: 4, lg: 4, sm: 6 }}>
                        <StatusForMaterial />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 4, lg: 4, sm: 6 }}>
                        <StatusForManpower />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 4, lg: 4, sm: 6 }}>
                        <StatusForSpecialised />
                    </Grid2>
                </Grid2> */}
                <Grid2 container spacing={1.25} rowSpacing={1.25} sx={{ mt: "10px", }}>
                    <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                        <TopPerformingVendors />
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 6, lg: 6 }}>
                        <NonPerformingVendors />
                    </Grid2>
                </Grid2>
                <Grid2 container spacing={1} sx={{ mt: "10px" }}>
                    <Grid2 size={{ xs: 12, md: 12, lg: 12 }}>
                        <VendorListData />
                    </Grid2>
                </Grid2>
                <Grid2 container spacing={1} sx={{ mt: "10px" }}>
                    <Grid2 size={{ xs: 12, md: 12, lg: 12 }}>
                        <VendorHeatmap />
                    </Grid2>
                </Grid2>
            </CustomTabPanel>

            <CustomTabPanel value={value} index={1}>
                <Grid2 size={12} sx={{ mt: "20px" }}>
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems={{ xs: "flex-start", md: "center" }}
                        flexDirection={{ xs: "column", md: "row" }}
                        gap={1}
                    >
                        <Typography
                            variant="h5"
                            sx={{
                                fontSize: '20px',
                                fontWeight: '500',
                                color: "#000000",
                                mb: { xs: 0.5, md: 1 },
                                lineHeight: "100%",
                                letterSpacing: '-0.4px',
                                textAlign: { xs: "center", md: "left" },
                                width: { xs: "100%", md: "auto" },
                            }}
                        >
                            Status overview of all Projects
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                fontWeight: '400',
                                color: "#858EA0",
                                mb: { xs: 1, md: 1 },
                                lineHeight: "100%",
                                letterSpacing: '-0.4px',
                                textAlign: { xs: "center", md: "right" },
                                width: { xs: "100%", md: "auto" },
                            }}
                        >
                            Last Modified on 10th June 2025
                        </Typography>
                    </Box>
                    <Typography
                        variant="h5"
                        sx={{
                            fontSize: '18px',
                            fontWeight: '400',
                            mb: "30px",
                            color: '#182A4E80',
                            lineHeight: "100%",
                            letterSpacing: '-0.4px',
                            textAlign: { xs: "center", md: "left" },
                        }}
                    >
                        Get the snapshot of the status of all your currently running projects. You can also navigate to the individual project dashboards
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                    <Grid2 container spacing={1.25}>
                        <Grid2 size={{ xs: 12, md: 12 }} sx={{ height: "568px" }}>
                            <MaterialReceiptTrend />
                        </Grid2>
                        {/* <Grid2 size={{ xs: 12, md: 12 }} sx={{ height: "600px" }}>
                            <PlanActualProcurement />
                        </Grid2> */}
                        {/* <Grid2 size={{ xs: 12, md: 4 }}>
                            <PlanActualProcurement />
                        </Grid2>
                        <Grid2 size={{ xs: 12, md: 4 }}>
                            <Budget />
                        </Grid2>
                        <Grid2 size={{ xs: 12, md: 4 }}>
                            <BOQ />
                        </Grid2> */}


                        <Grid2 size={{ xs: 12, md: 7 }} sx={{ height: "424px" }}>
                            <SCurveProcurement />
                        </Grid2>

                        <Grid2 size={{ xs: 12, md: 5 }}>
                            <Grid2 container direction="column" spacing={1.25}>
                                <Grid2 size={12} sx={{ height: "236px" }}>
                                    <LongLeadItems />
                                </Grid2>
                                <Grid2 size={12}>
                                    <LongLeadItemsSecond />
                                </Grid2>
                            </Grid2>
                        </Grid2>
                        <Grid2 size={{ xs: 12, md: 12 }} sx={{ height: "424px" }}>
                            <MaterialReceiptList />
                        </Grid2>

                    </Grid2>
                </Grid2>
            </CustomTabPanel>
        </>
    );
};

export default Procurement;